var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsAllOn = function SvgPartsAllOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.114 14.218-1.015 2.89H11.1zm1.71 5.029-.449-1.308H8.806l-.448 1.308H7.307l2.386-6.51h.796l2.386 6.51zM14.56 19.247v-6.51h.987v5.623h3.136v.887zM20.57 19.247v-6.51h.987v5.623h3.136v.887zM6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143M5.133 8.7 2.868 6.435l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsAllOn;